import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';
import { Icon } from '/imports/ui/Icon';

type BladeProps = {
  open?: boolean;
  className?: string;
  children: React.ReactNode;
  onClose?(): void;
};

const BladeStyled = styled.div`
  position: fixed;
  z-index: 3;
  top: calc(${css.appHeaderHeight} + 2px);
  right: -100%;
  background: ${css.white};
  transition: right 0.5s cubic-bezier(.53,.19,0,1);
  height: calc(100% - ${css.appHeaderHeight} - 2px);
  width: 100%;
  max-width: 35rem;
  border-left: 2px solid ${css.black};
  box-sizing: border-box;
  ${css.mobileMedia} {
    max-width: 100%;
    height: calc(100% - ${css.appHeaderHeight} - ${css.footerNavHeight} - 4px);
  }
  &.open {
    box-shadow: -8px 0px 10px -7px rgba(0,0,0,0.66);
    right: 0;
    opacity: 1;
    .overlay {
      display: block;
    }
  }
  .close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 5;
    cursor: pointer;
    svg {
      * {
        stroke: #9ca3af;
        stroke-width: 2;
      }
    }
  }
  .blade-body {
    position: relative;
    z-index: 4;
    padding: 3.5rem 2rem 2rem 2rem;
    box-sizing: border-box;
  }
  .overlay {
    display: none;
    position: fixed;
    top: calc(${css.appHeaderHeight} + 2px);
    left: 0;
    z-index: 3;
    height: calc(100% - ${css.appHeaderHeight} - 2px);
    background-color: transparent;
    ${css.mobileMedia} {
      height: calc(100% - ${css.appHeaderHeight} - ${css.footerNavHeight} - 4px);
    }
  }
`;

/** Slide-in side panel that animates from the right edge; click overlay or close icon to dismiss. */
export const Blade = (props: BladeProps) => {
  const { open, className, children } = props;
  return (
    <BladeStyled className={`blade${className ? ` ${className}` : ''}${open ? ' open' : ''}`}>
      <div className="overlay" onClick={() => props.onClose?.()} style={{width: 'calc(100% - 35rem)'}}></div>
      <div className="blade-body">{children}</div>
      <Icon className="close" icon="close" onClick={() => props.onClose?.()} />
    </BladeStyled>
  );
};